import SocketError from './SocketError';

export default SocketError;
